// src/helpers/htmlText.ts
// Giải mã ký tự HTML (VD "v&#233; lỗi" -> "vé lỗi"). Một số API cũ lưu ghi chú dạng HtmlEncode; React đã
// tự escape khi render nên FE chỉ cần decode về chữ thường để hiển thị đúng, KHÔNG dùng
// dangerouslySetInnerHTML.

let decoderElement: HTMLTextAreaElement | null = null;

export const decodeHtmlEntities = (value?: string | null): string => {
  if (!value) return '';
  if (!value.includes('&')) return value;
  if (typeof document === 'undefined') return value;
  if (!decoderElement) decoderElement = document.createElement('textarea');
  decoderElement.innerHTML = value;
  return decoderElement.value;
};
